import { Button, Stack, alpha } from "@mui/material";
import { motion } from "framer-motion";
import { WhatsApp, Email, ArrowForward, LinkedIn } from "@mui/icons-material";

const HeroButtons = () => {
  const buttonVariants = {
    hover: {
      scale: 1.05,
      transition: { duration: 0.3, ease: "easeOut" },
    },
    tap: {
      scale: 0.95,
    },
  };

  const handleWhatsAppClick = (e) => {
    e.preventDefault();
    window.open('https://wa.me/27720100332', '_blank', 'noopener,noreferrer');
  };

  return (
    <Stack direction={{ xs: "column", sm: "row" }} spacing={2.5}>
      {/* WhatsApp Button - Original WhatsApp Colors */}
      <motion.div
        variants={buttonVariants}
        whileHover="hover"
        whileTap="tap"
      >
        <Button
          variant="contained"
          startIcon={<WhatsApp />}
          onClick={handleWhatsAppClick}
          sx={{
            background: "linear-gradient(135deg, #25D366 0%, #128C7E 100%)",
            color: "#fff",
            fontWeight: 700,
            fontSize: "1rem",
            px: 4,
            py: 1.5,
            borderRadius: "50px",
            textTransform: "none",
            boxShadow: "0 4px 15px rgba(37, 211, 102, 0.3)",
            border: "1px solid rgba(255,255,255,0.1)",
            transition: "all 0.3s ease",
            "&:hover": {
              background: "linear-gradient(135deg, #20B859 0%, #0E6B5E 100%)",
              boxShadow: "0 6px 20px rgba(37, 211, 102, 0.4)",
              transform: "translateY(-2px)",
            },
            "& .MuiButton-startIcon": {
              marginRight: 1.5,
              "& svg": {
                fontSize: 24,
              },
            },
          }}
        >
          WhatsApp John
        </Button>
      </motion.div>

      {/* Email Button - Fixed email address */}
      <motion.div
        variants={buttonVariants}
        whileHover="hover"
        whileTap="tap"
      >
        <Button
          variant="outlined"
          startIcon={<Email />}
          href="mailto:john.asfar@worldwidecorporation.com"
          sx={{
            borderColor: alpha("#C8A96B", 0.5),
            color: "#C8A96B",
            fontWeight: 600,
            fontSize: "1rem",
            px: 4,
            py: 1.5,
            borderRadius: "50px",
            textTransform: "none",
            background: alpha("#C8A96B", 0.05),
            backdropFilter: "blur(10px)",
            transition: "all 0.3s ease",
            "&:hover": {
              borderColor: "#C8A96B",
              background: alpha("#C8A96B", 0.15),
              transform: "translateY(-2px)",
              boxShadow: "0 4px 15px rgba(200,169,107,0.2)",
            },
            "& .MuiButton-startIcon": {
              marginRight: 1.5,
              "& svg": {
                fontSize: 22,
              },
            },
          }}
        >
          Email John
        </Button>
      </motion.div>

      {/* LinkedIn Button - Keep as is */}
      <motion.div
        variants={buttonVariants}
        whileHover="hover"
        whileTap="tap"
      >
        <Button
          variant="outlined"
          startIcon={<LinkedIn />}
          href="https://linkedin.com/in/johnasfar"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            borderColor: alpha("#C8A96B", 0.5),
            color: "#C8A96B",
            fontWeight: 600,
            fontSize: "1rem",
            px: 4,
            py: 1.5,
            borderRadius: "50px",
            textTransform: "none",
            background: alpha("#C8A96B", 0.05),
            backdropFilter: "blur(10px)",
            transition: "all 0.3s ease",
            "&:hover": {
              borderColor: "#C8A96B",
              background: alpha("#C8A96B", 0.15),
              transform: "translateY(-2px)",
              boxShadow: "0 4px 15px rgba(200,169,107,0.2)",
            },
            "& .MuiButton-startIcon": {
              marginRight: 1.5,
              "& svg": {
                fontSize: 22,
              },
            },
          }}
        >
          LinkedIn
        </Button>
      </motion.div>
    </Stack>
  );
};

export default HeroButtons;